import { useCallback, PropsWithChildren, ReactNode } from 'react';

import Wrapper, { Input, LabelText } from './Wrapper';

export { LabelText };

export enum RadioButtonSizes {
  big = 'big',
  small = 'small'
}

export type RadioButtonProps<T, N = string> = {
  name: N;
  value: string;
  label: ReactNode;
  isChecked: boolean;
  size?: RadioButtonSizes;
  disabled?: boolean;
  className?: string;
  onChange(val: T): void;
};

const RadioButton = <T extends string>({
  name,
  value,
  label,
  onChange,
  disabled,
  isChecked,
  className,
  size = RadioButtonSizes.small
}: PropsWithChildren<RadioButtonProps<T>>) => {
  const handleChange = useCallback(() => onChange(value as T), [value, onChange]);

  return (
    <Wrapper {...{ className, size }}>
      <label>
        <Input
          type="radio"
          checked={isChecked}
          onChange={handleChange}
          {...{ name, value, ...(disabled && { disabled }) }}
        />
        <LabelText disabled={disabled} checked={isChecked}>
          {label}
        </LabelText>
      </label>
    </Wrapper>
  );
};

export default RadioButton;
